// Components
import Accordion from './Accordion'
import AudioPlayer from './AudioPlayer'
import AudioPlayerV2 from './AudioPlayer/v2/AudioPlayer'
import AdvancedTable from './AdvancedTable'
import AdvTableSearchComponent from './AdvancedTable/AdvTableSearchComponent'
import ActionButton from './Buttons/ActionButton'
import AlertButton from './Buttons/AlertButton'
import Avatar from './Avatar'
import Badge, { BadgeColor } from './Badge'
import BadgeV2 from './Badge/v2'
import Banner from './Banner'
import Box from './Box'
import BodyPortal from './BodyPortal'
import Breadcrumbs from './Breadcrumbs'
import Button, { Button as BaseButton } from './Buttons/Button'
import ButtonV2 from './Buttons/Button/v2'
import Checkbox from './Checkboxes/Checkbox'
import EditableCheckbox from './Checkboxes/Checkbox/EditableCheckbox'
import ChipComponents from './Chip'
import Card from './Card'
import CardV2 from './Card/v2'
import CopytoClipBoardButton from './CopyToClipBoard'
import CopyToClipBoardInput from './ClipBoardCopyInput'
import ConfirmationModal from './ConfirmationModal'
import Dot from './Dot'
import RouteConfirmationModal from './ConfirmationModal/RouteConfirmationModal'
import CustomField from './CustomField'
import DatePicker from './DatePicker'
import DateWithToolTip from './DateWithToolTip'
import Divider from './Divider'
import DragAndDrop from './DragAndDrop'
import Dropdown from './Dropdown'
import DropdownV2 from './DropdownV2'
import { ErrorMessage, HintMessage } from './TextInput'
import Flex from './Flex'
import Field from './Field'
import Footer from './Footer'
import JsonPresenter from './JsonPresenter'
import Icon, { IconBg, IconProps as IcProps } from './Icon'
import type { IconBgProps as IcBGProps } from './Icon'
import IconButton from './Buttons/IconButton'
import IndeterminateCheckbox from './Checkboxes/IndeterminateCheckBox'
import InlineEditableInput from './InlineEditableInput'
import InlineEditableInputV2 from './InlineEditableInput/v2'
import InlineError from './InlineError'
import InlineNotification from './Notifications/InlineNotification'
import InputAddDropdown from './InputAddDropdown'
import LeadStatusTimeLine, { StatusProps } from './LeadStatusTimeLine'
import LinedAddButton from './Buttons/LinedAddButton'
import LinedTitle from './LinedTitle'
import Modal from './Modal'
import MoreOptionsPopOver from './MoreOptionsPopOver'
import MoreOptionsPopOverV2 from './MoreOptionsPopOver/v2'
import MenuList, { OptionType } from './MenuList'
import MenuOptions, { MenuDropdownProps } from './MenuOptions'
import MenuOptionsV2 from './MenuOptions/v2'
import NavigationTab from './NavigationTab'
import NumberInput from './NumberInput'
import Panel from './Panel'
import PhoneInput, { FormattedPhoneNumber } from './PhoneInput'
import PhotoEditor from './PhotoEditor'
import PopOver from './PopOver'
import PopOverMenuList from './PopOver/MenuList'
import Progress from './Progress'
import SearchableMenuList from './PopOver/SearchMenuList'
import { CustomMenuProps, PopOverItem, TextCase } from './PopOver/types'
import Popup from './Popup'
import ProfileDropdown from './ProfileDropdown'
import RadioBox from './RadioBox'
import RadioGroup from './RadioGroup'
import RightPanel from './RightPanel'
import RouteGuard from './Route'
import Search from './Search'
import SearchPlace, { SearchResult } from './SearchPlace'
import SettingsDropdown from './SettingsDropdown'
import SimpleNavigationTabs from './SimpleNavigationTabs'
import Skeleton from './SkeletonLoader'
import Slider from './Slider'
import Spinner from './Spinner'
import { Stepper, StepProps } from './Stepper'
import SwitchButton from './Buttons/SwitchButton'
import Table, { TableProps as TProps, ColumnWidthType as ColWidthType, PaginationType } from './Table'
import TabularCheckbox from './TabularCheckbox'
import { filterColumns, orderColumns } from './Table/helpers'
import { SorterStatus } from './Table/TableHeader'
import Text from './Text'
import DynamicText from './Text/DynamicText'
import TextButton from './Buttons/TextButton'
import TextInput from './TextInput'
import TextInputV2 from './TextInput/v2'
import Toast from './Toast'
import Tooltip from './Tooltip'
import UploadModal, { UploadAndCropModal } from './UploadModal'
import VirtualizedList from './VirtualizedList'
import VirtualizedListV2 from './VirtualizedList/v2'
import Ribbon from './Ribbon'
import NotificationPanel from './NotificationPanel'
import StepperTitle from './StepperTitle'
import IconLink from './IconLink'
import SideMenu from './SideMenu'
import Switch from './Switch'
import DragAndDropList from './DragAndDropList'
import ChipInput from './ChipInput'
import LoadingModal from './LoadingModal'
import DynamicContainer from './DynamicContainer'
import PasscodeInput from './PasscodeInput'
import DynamicInput from './DynamicInput'
import PanelSection from './PanelSection'
import ActivateButton from './Buttons/ActivateButton'
import LoadingView from './LoadingView'
import ErrorView from './ErrorView'
import EmptyView from './EmptyView'
import NoResults from './NoResults'
import ToggleSwitch from './ToggleSwitch'
import MultiThumbRangeInput from './RangeInput'
import TextWithEllipsedCount from './TextWithEllipsedCount'
import { isLegacy, LeadDetailsDesignVersion } from './utils/designVersionHelpers'

export {
  Accordion,
  ActionButton,
  ActivateButton,
  AdvancedTable,
  AdvTableSearchComponent,
  AlertButton,
  AudioPlayer,
  AudioPlayerV2,
  Avatar,
  Badge,
  BadgeV2,
  Banner,
  BaseButton,
  Box,
  BodyPortal,
  Breadcrumbs,
  Button,
  ButtonV2,
  Card,
  CardV2,
  Checkbox,
  EditableCheckbox,
  ChipComponents,
  ChipInput,
  ConfirmationModal,
  CopytoClipBoardButton,
  CopyToClipBoardInput,
  CustomField,
  DatePicker,
  DateWithToolTip,
  Divider,
  Dot,
  DragAndDrop,
  DragAndDropList,
  Dropdown,
  DropdownV2,
  DynamicContainer,
  DynamicInput,
  EmptyView,
  ErrorMessage,
  ErrorView,
  Flex,
  Field,
  filterColumns,
  Footer,
  HintMessage,
  Icon,
  IconBg,
  IconButton,
  IconLink,
  IndeterminateCheckbox,
  InlineEditableInput,
  InlineEditableInputV2,
  InlineError,
  InlineNotification,
  InputAddDropdown,
  JsonPresenter,
  LeadStatusTimeLine,
  LinedAddButton,
  LinedTitle,
  LoadingModal,
  LoadingView,
  MenuList,
  MenuOptions,
  MenuOptionsV2,
  Modal,
  MoreOptionsPopOver,
  MoreOptionsPopOverV2,
  NavigationTab,
  NotificationPanel,
  NumberInput,
  orderColumns,
  Panel,
  PanelSection,
  PasscodeInput,
  PhoneInput,
  PhotoEditor,
  PopOver,
  PopOverMenuList,
  Popup,
  ProfileDropdown,
  Progress,
  RadioBox,
  RadioGroup,
  Ribbon,
  RightPanel,
  RouteGuard,
  RouteConfirmationModal,
  Search,
  SearchPlace,
  SearchableMenuList,
  SettingsDropdown,
  SideMenu,
  SimpleNavigationTabs,
  Skeleton,
  Slider,
  Spinner,
  Stepper,
  StepperTitle,
  Switch,
  SwitchButton,
  Table,
  TabularCheckbox,
  Text,
  TextWithEllipsedCount,
  DynamicText,
  TextButton,
  TextInput,
  TextInputV2,
  Toast,
  ToggleSwitch,
  Tooltip,
  UploadAndCropModal,
  UploadModal,
  VirtualizedList,
  VirtualizedListV2,
  NoResults,
  MultiThumbRangeInput,
  isLegacy,
}

export const Chip = ChipComponents.Chip
export const NewChip = ChipComponents.NewChip

export { default as ClickableCell } from './Table/ClickableCell'
export { default as PageHeader } from './PageHeader'

// Typings
import { FixMeAny, UnknownRecord } from 'types/global'
import { DropdownItem } from './Dropdown/types'

export type BadgeColorList = BadgeColor
export type ColumnWidthType = ColWidthType
export type DropdownItemType<T = string, D = FixMeAny> = DropdownItem<T, D>
export type FormattedPhoneNumberType = FormattedPhoneNumber
export type IconProps = IcProps
export type IconBgProps = IcBGProps
export type ListOptionType = OptionType
export type PopOverItemType<T = string> = PopOverItem<T>
export type PopOverTextCase = TextCase
export type PopOverCustomMenuType = CustomMenuProps
export type StepType = StepProps
export type TableProps<D extends UnknownRecord> = TProps<D>
export type PaginationProps = PaginationType
export type TableSorterStatus = SorterStatus
export type LeadTimeLineStatus = StatusProps
export type MenuDropdownOptions = MenuDropdownProps
export type ToastMessageVariant = 'info' | 'error' | 'success' | 'warning'
export type SearchPlaceResult = SearchResult
export type { LeadDetailsDesignVersion }
